export const ACCOUNT_TYPE = {
  Instructor:"Instructor",
  Student:"Student",
  Admin:"Admin"
}

export const COURSE_STATUS = {
  DRAFT:"Draft",
  PUBLISHED:"Published"
}